import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { Approval } from '@interfaces';

import { DialogApprovalsEquipmentsApproveComponent } from './../dialog-approvals-approve/dialog-approvals-approve.component';
import { DialogApprovalsEquipmentsRejectComponent } from './../dialog-approvals-reject/dialog-approvals-reject.component';

@Component({
    selector: 'dialog-approvals-equipments',
    templateUrl: './dialog-approvals-equipments.component.html',
    styleUrls: ['./dialog-approvals-equipments.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DialogApprovalsEquipmentsComponent {
    public statusApproval: string;
    public disableButton = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public approval: Approval,
        private matDialog: MatDialog,
        public matDialogRef: MatDialogRef<DialogApprovalsEquipmentsComponent>
    ) {
        this.statusApproval = this.approval.status;
    }

    disableButtonApproval(isExistingNumber): void {
        this.disableButton = isExistingNumber;
    }

    openApproveDialog(): void {
        const equipmentsApprove = this.matDialog.open(DialogApprovalsEquipmentsApproveComponent, { panelClass: ['dialog-approvals-approve'], data: this.approval });
        equipmentsApprove.afterClosed().subscribe((reload) => {
            if (reload) { this.matDialogRef.close(true); }
        });
    }

    openRejectDialog(): void {
        const equipmentsReject = this.matDialog.open(DialogApprovalsEquipmentsRejectComponent, { panelClass: ['dialog-approvals-reject'], data: this.approval });
        equipmentsReject.afterClosed().subscribe((reload) => {
            if (reload) { this.matDialogRef.close(true); }
        });
    }
}
